import {contextPath} from "site";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";

import {ThirdPartyDataSharingAircraftSeries} from "./third-party-data-sharing-aircraft-series";

const apiURL = `${contextPath}/api`;
const thirdPartyDataSharingAircraftSeriesURL = `${apiURL}/third-party-data-sharing/aircraft-series`;

@Injectable()
export class ThirdPartyDataSharingAircraftSeriesService {
	constructor(private http: HttpClient) {}

	/**
	 * Query search to obtain an array of ThirdPartyDataSharingAircraftSeries objects.
	 * @param aircraftSeriesID  to answer what third parties are available to share data with for this aircraft series.
	 * @return Array of {@link ThirdPartyDataSharingAircraftSeries} objects matching aircraftSeriesID.
	 */
	getThirdPartyDataSharingByAircraftSeriesId(aircraftSeriesID: number): Observable<Array<ThirdPartyDataSharingAircraftSeries>> {
		return this.http.get<Array<ThirdPartyDataSharingAircraftSeries>>(`${thirdPartyDataSharingAircraftSeriesURL}/${aircraftSeriesID}/third-parties`)
			.map(response => (response as Array<any>)
				.map(json => ThirdPartyDataSharingAircraftSeries.fromJSON(json)))
	}
}
